/* eslint-disable import/prefer-default-export */
export const setEditedInfaq = (data) => ({
  type: 'EDITED INFAQ',
  payload: data,
});
